export const secaoConhecimentos = {
    titulo: "Conhecimentos adquiridos ao longo da carreira",
    descricao:
        "Abaixo estão tecnologias, ferramentas e práticas que fazem parte da minha trajetória profissional em TI, construída entre infraestrutura, suporte, desenvolvimento de software e evolução contínua de produtos.",
    grupos: [
        {
            categoria: "Front-end e frameworks",
            itens: ["React", "Next.js", "JavaScript", "TypeScript", "CSS Modules", "Angular", "jQuery", "Tailwind CSS", "Bootstrap"]
        },
        {
            categoria: "Back-end e frameworks",
            itens: [
                "Java",
                "Spring Boot",
                "Quarkus",
                "C#",
                ".NET",
                "ASP.NET Core",
                "Entity Framework",
                "Go",
                "Gin",
                "PHP",
                "Laravel",
                "Python",
                "APIs REST",
                "JWT"
            ]
        },
        {
            categoria: "Containers e orquestração",
            itens: ["Docker", "Docker Swarm", "Kubernetes"]
        },
        {
            categoria: "Bancos de dados",
            itens: ["PostgreSQL", "MySQL"]
        },
        {
            categoria: "CI/CD e qualidade",
            itens: ["Jenkins", "GitHub Actions", "Versionamento com Git"]
        },
        {
            categoria: "Metodologias ágeis e práticas",
            itens: ["Scrum", "Kanban", "XP", "Lean", "Entrega contínua"]
        }
    ]
};
